import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
render(<BrowserRouter data-id="element-145">
    <Routes data-id="element-146">
      <Route path="/" element={<App data-id="element-148" />} data-id="element-147" />
      <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-150" />} data-id="element-149" />
    </Routes>
  </BrowserRouter>, document.getElementById('root'));